<div class="min-h-screen flex flex-col">
  <app-private-navbar></app-private-navbar>

  <main class="w-full flex-1 pb-[90px] md:pb-[90px] lg:pb-0 pt-[113px] md:pt-[84px]">
    <router-outlet></router-outlet>
  </main>

  <app-public-footer variant="private"></app-public-footer>
</div>

@if (toastService.message(); as msg) {
  <div class="pointer-events-none fixed inset-x-0 top-[80px] z-[300] flex justify-center px-[16px]">
    <div class="pointer-events-auto w-full max-w-[400px]">
      <app-alert [variant]="msg.variant" [message]="msg.text" (closed)="toastService.clear()"></app-alert>
    </div>
  </div>
}

<app-quotation-progress-toast></app-quotation-progress-toast>

@defer (when profileGate.open()) {
  <app-profile-completion-modal
    [open]="profileGate.open()"
    [user]="profileGate.user()"
    [missing]="profileGate.missing()"
    (completed)="profileGate.complete()">
  </app-profile-completion-modal>
}
